module.exports = "/_next/static/images/favicon-32-4f9d52413f3071cea618d32e0019c7a4.png";